import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
// import { SlimLoadingBarModule } from 'ops-lib';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthorizeDirective } from '../directives/authorize.directive';
import { OpsLibModule } from 'ops-lib';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    OpsLibModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    OpsLibModule,
    AuthorizeDirective,
  ],
  declarations: [
    AuthorizeDirective,
  ],
  providers: [],
})
export class MainSharedModule {}
